
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/disclaimer",
      function () {
        return require("private-next-pages/en/ir/disclaimer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/disclaimer"])
      });
    }
  